<template>
  <div class="list row">
    <div class="col-md-6">
      <h4>Stevner</h4>
      <ul class="list-group">
        <li class="list-group-item"
          :class="{ active: index == currentIndex, 'bg-success': competition.adminApproved, 'bg-secondary': competition.hidden }"
          v-for="(competition, index) in this.activeCompetitions"
          :key="index"
          @click="setActiveCompetition(competition, index)"
        >
        <!-- <font-awesome-icon icon="user-plus"/> -->
        <!-- <font-awesome-icon icon="cloud-upload-alt"/> -->
        <font-awesome-icon v-if="competition.origin_system && competition.origin_system == 'opentrack'" icon="cloud-upload-alt"></font-awesome-icon>
        <font-awesome-icon v-else icon="running"></font-awesome-icon>
        <!-- <font-awesome-icon v-else icon="running"></font-awesome-icon> -->
        <span :style="{ textDecoration: competition.hidden ? 'line-through' : 'none' }">
            {{ competition.id }} - {{ competition.name }} ({{ competition.date_start | formatDate_onlyDate }} - {{ competition.date_end | formatDate_onlyDate }})
        </span>
        </li>
      </ul>

    </div>
    <div class="col-md-6">
      <div v-if="currentCompetition" style="position: sticky; top: 0; background: white; z-index: 1000; padding: 10px; border-bottom: 1px solid #ccc;">
        <!-- <Competition competition_id=currentCompetition.id></Competition> -->
        <h4>Stevne</h4>
        <div>
          <label><strong>Navn:</strong></label>
          <span :style="{ textDecoration: currentCompetition.hidden ? 'line-through' : 'none' }">
            {{ currentCompetition.name || "NoName" }}
          </span>
        </div>
        <div>
          <label><strong>Valgte funksjoner:</strong></label>
          <div v-if="currentCompetition.functions && currentCompetition.functions.length">
            <ul style="list-style-type: none; padding-left: 0;">
              <li v-for="func in currentCompetition.functions" :key="func.id">
              <div v-if="func === 'opprop'">
                <input type="checkbox" id="opprop" name="function" value="opprop" v-model="currentCompetition.functions" disabled>
                <label for="opprop">Frisys - Opprop</label>
              </div>
              <div v-else-if="func === 'liveres'">
                <input type="checkbox" id="liveres" name="function" value="liveres" v-model="currentCompetition.functions" disabled>
                <label for="liveres">Frisys - Liveres</label>
              </div>
              </li>
            </ul>
          </div>
          <div v-else style="background-color: red; color: white;">
            Ingen funksjoner er valgt
          </div>
        </div>
        <div>
          <label><strong>Stevnenummer:</strong></label> {{ currentCompetition.id }}
        </div>
        <div v-if="currentCompetition.hash">
          <label><strong>Stevnekode:</strong></label> {{ currentCompetition.hash }}
        </div>
        <div>
          <label><strong>Dato:</strong></label> {{ currentCompetition.date_start | formatDate_onlyDate}} - {{ currentCompetition.date_end | formatDate_onlyDate}}
        </div>
        <div>
          <label><strong>Nivå:</strong></label> {{ currentCompetition.level }}
        </div>
        <div>
          <label><strong>Arrangør:</strong></label> {{ currentCompetition.organizer }}
        </div>
        <div>
            <label><strong>Web:</strong></label>
            <a :href="currentCompetition.external_webpage" target="_blank">
            {{ currentCompetition.external_webpage }}
            </a>
        </div>
        <div>
          <label><strong>Stadion:</strong></label> {{ currentCompetition.venue_id }}
        </div>
        <div>
          <label><strong>Tilhørighet:</strong></label> {{ currentCompetition.affiliation && currentCompetition.affiliation.field }} = {{ currentCompetition.affiliation && currentCompetition.affiliation.title }}
        </div>
        <div>
          <label><strong>Publiseringsdato:</strong></label> {{ currentCompetition.publishDate | formatDate_onlyDate }}
        </div>
        <div>
          <label><strong>Skjul m. opprop etter resultat:</strong></label> {{ currentCompetition.hideMissingCallroomAfterFirstResult ? "Valgt" : "Ikke valgt" }}
        </div>
        <div>
          <label><strong>Skjult:</strong></label>
          <span>
          {{ currentCompetition.hidden ? "Skjult" : "Synlig" }}
          </span>
        </div>
        <div>
            <label><strong>Aktivering:</strong></label>
            <span :class="currentCompetition.hidden ? '' : (currentCompetition.adminApproved ? 'badge badge-success' : 'badge badge-warning')">
            {{ currentCompetition.adminApproved ? "Aktivert" : "Ikke aktivert" }}
            </span>
        </div>
        <div v-if="currentCompetition.origin_system !== 'opentrack'">
          <router-link :to="'/callroom/upload/'+ currentCompetition.id +'/'+ currentCompetition.hash">Last opp oppropsdata fra Frisys</router-link>
        </div>
        <div>
          <a
          :href=link_data_url(currentCompetition)
          v-text=link_data_label(currentCompetition)
          @click.prevent="downloadCompetitionFile({
            url: link_data_url(currentCompetition), 
            label: link_data_label(currentCompetition)
          })"></a><br>
        </div>
        <div>
          <a
          :href=link_data_url2(currentCompetition)
          v-text=link_data_label2(currentCompetition)
          @click.prevent="downloadCompetitionFile({
            url: link_data_url2(currentCompetition), 
            label: link_data_label2(currentCompetition)
          })"></a><br>
        </div>

        <a v-if="checkRole('frisys_admin') || ((checkRole('competition_admin') && (!currentCompetition.id || checkRole('competition_admin', currentCompetition.id))) && !currentCompetition.hidden && new Date(currentCompetition.date_end) > new Date())" class="badge badge-warning"
          :href="'/competition/'+currentCompetition.id+'/edit'"
        >
          Endre stevne
        </a>
        <div v-else>
          Ved behov for endringer: kontakt Andro (Torgeir, Sigurd eller Roar)
        </div>
        <div>
          <router-link :to="'/competition/' + currentCompetition.id + '/admin'" class="badge badge-success">
          Åpne i StevneAdmin
          </router-link>
        </div>
      </div>
      <div v-else>
        <br />
        <p>Stevneinfo...</p>
      </div>
    </div>
  </div>
</template>

<script>
import CompetitionDataService from "../services/CompetitionDataService";
import MyComputed from "../myComputed";
// import Competition from "./Competition.vue";

// TODO: Replace Competition with the actual Competition component

export default {
  mixins: [MyComputed],
  name: "competitions-list",
  components: {
    // Competition
  },
  data() {
    return {
      competitions: [],
      currentIndex: -1,
      title: ""
    };
  },
  methods: {
    retrieveCompetitions() {
      this.$store.dispatch('competition/updateActiveCompetitions');
    },
    downloadCompetitionFile ({ url, label }) {
      CompetitionDataService.getCompetitionFile({url, label});
    },
    link_data_url(currentCompetition) {
      return "/api/competition/download/"+ currentCompetition.id + "/" + currentCompetition.hash;
    },
    link_data_url2(currentCompetition) {
      return "/api/competition/download/"+ currentCompetition.id + "/" + currentCompetition.hash + "/events";
    },
    link_data_label(currentCompetition) {
      return "frisys_competition_"+ currentCompetition.id + ".json";
    },
    link_data_label2(currentCompetition) {
      return "frisys_events_"+ currentCompetition.id + ".json";
    },

    refreshList() {
      this.retrieveCompetitions();
      this.currentIndex = -1;
    },

    setActiveCompetition(competition, index) {
      this.currentIndex = index;
    },

    removeAllCompetitions() {
      CompetitionDataService.deleteAll()
        .then(response => {
          console.log(response.data);
          this.refreshList();
        })
        .catch(e => {
          console.log(e);
        });
    },
    
    searchTitle() {
      CompetitionDataService.findByTitle(this.title)
        .then(response => {
          this.competitions = response.data;
          console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    }
  },
  filters: {
    formatDate_onlyDate(value) {
      const date = new Date(value);
      return date.toLocaleDateString("no-NO", { year: 'numeric', month: 'numeric', day: 'numeric' });
    }
  },
  mounted() {
    this.retrieveCompetitions();
  },
  computed: {
    // Extract currentCompetition object from store, based on currentCompetitionId
    currentCompetition: {
      cache: false,
      get() {
        // console.log("currentCompetition");
        // console.log(this.currentIndex);
        // console.log(this.$store.state.competition.activeCompetitions);
        // If we have activeCompetitions, and currentIndex is set: lookup the competition object from the activeCompetitions array with the index of currentIndex
        let competition = this.$store.state.competition.activeCompetitions && this.$store.state.competition.activeCompetitions[this.currentIndex];
        // console.log(competition);
        return competition;
      }
    },
  }
};
</script>

<style>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}
</style>
